export const jobEducationLevelsEn = {
  jobEducationLevels: {
    'no_education_required': 'No education required',
    'primary_education': 'Primary education',
    'secondary_education': 'Secondary education',
    'complete_secondary_education': 'Complete secondary education (High school diploma)',
    'bachelors_degree': 'Bachelor\'s degree',
    'masters_degree': 'Master\'s degree',
    'doctoral_degree': 'Doctoral degree (PhD)'
  }
};
